module.exports = __webpack_public_path__ + "media/images/cliparts/Goals 3-87d3d3a2e6f322d51e88694d00b8e94f.svg";